import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlDocuments from './ControlDocuments.js';
import { getListDocuments } from '../../../Api/ExtranetActions.js'

declare var globalSns;
declare var globalExtranet;

class ExtranetDocuments extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }
    
    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getListDocuments(globalSns.languageId, globalExtranet.showOpenOnly, (data) => {
            this.setState({
                listdocuments: data
            });
        });
    }

    render() {
        if (this.state.listdocuments == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlDocuments documents={this.state.listdocuments} 
                        onNavigateToCandidates={(row) => this.props.onNavigate("extranetCandidatesFiche", row.personId, row.personFirstName + " " + row.personName)} 
                        onNavigateToProjects={(row) => this.props.onNavigate("extranetProjectsFiche", row.projectId, row.project)}
                        showDocumentType={true} />
                </div>
            </div>
        );
    }
}

export default ExtranetDocuments;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetDocuments.js